import React, { useEffect, useLayoutEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Invest from "../pages/Invest";
import Faq from "../pages/others/Faq";
import Regularv1 from "../pages/others/Regular-1";
import Regularv2 from "../pages/others/Regular-2";
import Terms from "../pages/others/Terms";
import UserProfileRegular from "../pages/pre-built/user-manage/UserProfileRegular";
import UserProfileSetting from "../pages/pre-built/user-manage/UserProfileSetting";
import UserProfileNotification from "../pages/pre-built/user-manage/UserProfileNotification";
import UserProfileActivity from "../pages/pre-built/user-manage/UserProfileActivity";

import Error404Modern from "../pages/error/404-modern";
import Login from "../pages/auth/Login";
import Register from "../pages/auth/Register";
import Success from "../pages/auth/Success";

import Layout from "../layout/Index";
import LayoutNoSidebar from "../layout/Index-nosidebar";

//Procurex Pages

import InvoicePayables from "../pages/payments/invoicePayables";
import PendingPaymentApprovals from "../pages/payments/pendingPaymentApprovals";
import RunPayments from "../pages/payments/runPayments";
import ViewPayments from "../pages/payments/viewPayments";
import CreatePayment from "../pages/payments/CreatePayment";
import { useDispatch } from "react-redux";
import { fetchCurrentUser } from "../store/slices/misc/currentUser";

import PaymentsAnalytics from "../pages/payments/PaymentsAnalytics";
import { useSelector } from "react-redux";
import { updateAccessibility } from "../store/slices/misc/accessibility";
import { updateMenuData } from "../store/slices/misc/menuData";
import { Flex, Spin } from "antd";
import { updateAllowedRoutes } from "../store/slices/misc/allowedRoutes";
import { fetchSequenceAccess } from "../store/slices/misc/sequenceAccess";
import Cookies from "js-cookie";
import WorkBoqCreationMain from "../pages/work-boq/workBoqCreationMain";
import WorkBoqList from "../pages/work-boq/workBoqList";
import WorkBoqApprovals from "../pages/work-boq/workBoqApprovals";
import WorkBoqView from "../pages/work-boq/workBoqView";
import ExcelExportRequestedList from "../pages/pre-built/user-manage/ExcelExportRequestedList";
import NotificationMain from "../pages/notifications/NotificationMain";
import BulkUploadList from "../pages/pre-built/user-manage/ExcelUploadRequestedList";
import DefaultDashboardPage from "../pages/DefaultDashboard";
import { HomeOutlined } from "@ant-design/icons";
import WorkRequestList from "../pages/work-requests/workRequestList";
import WorkRequestCreationMain from "../pages/work-requests/workRequestCreationMain";
import WorkRequestApprovals from "../pages/work-requests/workRequestApprovals";
import WorkRequestView from "../pages/work-requests/workRequestView";
import WorkOrderCreationMain from "../pages/work-orders/workOrderCreationMain";
import ViewWorkOrder from "../pages/work-orders/ViewWorkOrder";
import WorkOrderView from "../pages/work-orders/workOrderView";
import PendingWorkOrderApprovals from "../pages/work-orders/PendingWorkOrderApprovals";
import UnderWorkExecution from "../pages/work-executions/UnderWorkExecution";
import PendingExecutionApprovals from "../pages/work-executions/PendingExecutionApprovals";
import ClosedWorks from "../pages/work-executions/ClosedWorks";
import WorkExecutionView from "../pages/work-executions/WorkExecutionView";
import WorkOrderAmendments from "../pages/work-orders/WorkOrderAmendments";
import FinalizedWorkOrders from "../pages/work-orders/FinalizedWorkOrders";
import CreateRABills from "../pages/ra-bills/CreateRABills";
import CreateRABillDetails from "../pages/ra-bills/CreateRABillDetails";
import RABillsPendingApprovals from "../pages/ra-bills/RABillsPendingApprovals";
import ViewRABillsApproved from "../pages/ra-bills/ViewRABillsApproved";
import RABillsOutstanding from "../pages/ra-bills/RABillsOutstanding";
import RABillsOverdue from "../pages/ra-bills/RABillsOverdue";
import RABillDetails from "../pages/ra-bills/RABillDetails";
import WorkOrderReportsContainer from "../pages/work-order-reports/WorkOrderReportsContainer";
import ReportView from "../pages/work-order-reports/ReportView";
import WorkExecutionBatchDetails from "../pages/work-executions/WorkExecutionBatchDetails";
import ProjectRiskDashboard from "../pages/project-management-control-tower/ProjectRiskDashboard";
import ProjectManagementControlTower from "../pages/project-management-control-tower/ProjectManagementControlTower";
import ProcurementInventoryControlTower from "../pages/procurement-inventory-control-tower/ProcurementInventoryControlTower";
import WorkOrderExecutionPaymentControlTower from "../pages/work-order-execution-payment-control-tower/WorkOrderExecutionPaymentControlTower";
import BudgetControlTower from "../pages/budget-control-tower/BudgetControlTower";
import IntegratedRiskControlTower from "../pages/integrated-risk-control-tower/IntegratedRiskControlTower";
const globalRoutes = [
  "/",
  "/auth-reset",
  "/auth-success",
  "/auth-register",
  "/setPassword",
  "/success",
  "/errorEmail",
  "/privacy",
  // "/notifications",
];
const routesMap = {
  dashboard: <Invest />,
  "invoice-payables": <InvoicePayables />,
  "create-payment": <CreatePayment />,
  "pending-payment-approvals": <PendingPaymentApprovals />,
  "run-payments": <RunPayments />,
  "view-payments": <ViewPayments />,
  "payment-analytics": <PaymentsAnalytics />,
  "payments-analytics": <PaymentsAnalytics />,
  "terms-policy": <Terms />,
  faq: <Faq />,
  privacy: <Faq />,
  "pages/regular-v1": <Regularv1 />,
  "pages/regular-v2": <Regularv2 />,
  "project-risk-dashboard": <ProjectManagementControlTower />,
  "procurement-inventory-control-tower": <ProcurementInventoryControlTower />,
  "work-order-execution-payment-control-tower": <WorkOrderExecutionPaymentControlTower />,
  "budget-control-tower": <BudgetControlTower />,
  "integrated-risk-control-tower": <IntegratedRiskControlTower />,
  // "project-risk-mitigation": <ProjectRiskMitigation />,
  // "project-control-indicators": <ProjectControlIndicators />,
  // "project-executive-summary": <ProjectExecutiveSummary />,
  // "project-list-view": <ProjectListView />,
  "*": <Error404Modern />,
};
const menu = [
  {
    text: "Risk Impact Dashboard",
    link: "integrated-risk-control-tower",
  },
  {
    text: "Project Management",
    link: "project-risk-dashboard",
    // subMenu: [
    //   {
    //     text: "Risk Summary Dashboard",
    //     link: "project-risk-dashboard",
    //   },
    //   {
    //     text: "Risk Mitigation",
    //     link: "project-risk-mitigation",
    //   },
    //   {
    //     text: "Control Indicators",
    //     link: "project-control-indicators",
    //   },
    //   {
    //     text: "Executive Summary",
    //     link: "project-executive-summary",
    //   },
    //   {
    //     text: "All Projects",
    //     link: "project-list-view",
    //   },
    // ],
  },
  {
    text: "Procurement & Inventory",
    link: "procurement-inventory-control-tower",
  },
  {
    text: "Work Order Execution & Payments",
    link: "work-order-execution-payment-control-tower",
  },
  {
    text: "Budget",
    link: "budget-control-tower",
  },
  // {
  //   text: "Integrated Risk Impact",
  //   link: "integrated-risk-control-tower",
  // },
];
const Pages = ({ setIsLoggedIn }) => {
  const { data: currentUser } = useSelector((state) => state.currentUser);
  const [accessibility, setAccessibility] = useState([]);
  const [restrictedRoutes, setRestrictedRoutes] = useState([]);
  const dispatch = useDispatch();
  const location = useLocation();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    const isAuthenticated = Cookies.get("access-token");
    if (
      !currentUser &&
      isAuthenticated &&
      !globalRoutes?.includes(window.location.pathname)
    ) {
      dispatch(fetchCurrentUser());
    }
  }, [dispatch]);

  useEffect(() => {
    if (currentUser?.userRoutePermissions) {
      try {
        dispatch(fetchSequenceAccess());
        const { userRoutePermissions } = currentUser;
        // const decodedString = atob(userRoutePermissions);
        const decodedString = {
          KYC: {
            menuItem: "KYC",
            access: true,
            routes: [
              { path: "kyc-list-regular", permission: true, pageType: "view" },
              {
                path: "kyc-details-regular/:kycId",
                permission: true,
                pageType: "view",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          Pages: {
            menuItem: "Pages",
            access: true,
            routes: [
              { path: "terms-policy", permission: true, pageType: "view" },
              { path: "faq", permission: true, pageType: "view" },
              { path: "regular-v1", permission: true, pageType: "view" },
              { path: "regular-v2", permission: true, pageType: "view" },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          Authentication: {
            menuItem: "Authentication",
            access: true,
            routes: [
              { path: "auth-success", permission: true, pageType: "view" },
              { path: "auth-reset", permission: true, pageType: "view" },
              { path: "auth-register", permission: true, pageType: "add" },
              { path: "setPassword", permission: true, pageType: "add" },
              { path: "success", permission: true, pageType: "view" },
              { path: "errorEmail", permission: true, pageType: "view" },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          Errors: {
            menuItem: "Errors",
            access: true,
            routes: [
              { path: "errors/404-modern", permission: true, pageType: "view" },
              {
                path: "errors/404-classic",
                permission: true,
                pageType: "view",
              },
              { path: "errors/504-modern", permission: true, pageType: "view" },
              {
                path: "errors/504-classic",
                permission: true,
                pageType: "view",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          Dashboard: {
            menuItem: "Dashboard",
            access: true,
            routes: [{ path: "dashboard", permission: true, pageType: "view" }],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          ProjectManagementControlTower: {
            menuItem: "Project Management Control Tower",
            access: true,
            routes: [
              {
                path: "project-risk-dashboard",
                permission: true,
                pageType: "view",
              },
              {
                path: "project-risk-mitigation",
                permission: true,
                pageType: "view",
              },
              {
                path: "project-control-indicators",
                permission: true,
                pageType: "view",
              },
              {
                path: "project-executive-summary",
                permission: true,
                pageType: "view",
              },
              {
                path: "project-list-view",
                permission: true,
                pageType: "view",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          ProcurementInventoryControlTower: {
            menuItem: "Procurement & Inventory Control Tower",
            access: true,
            routes: [
              {
                path: "procurement-inventory-control-tower",
                permission: true,
                pageType: "view",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          WorkOrderExecutionPaymentControlTower: {
            menuItem: "Work Order Execution & Payment Risk Control Tower",
            access: true,
            routes: [
              {
                path: "work-order-execution-payment-control-tower",
                permission: true,
                pageType: "view",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          BudgetControlTower: {
            menuItem: "Budget Control Tower (By Project)",
            access: true,
            routes: [
              {
                path: "budget-control-tower",
                permission: true,
                pageType: "view",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          IntegratedRiskControlTower: {
            menuItem: "Integrated Risk Impact Control Tower",
            access: true,
            routes: [
              {
                path: "integrated-risk-control-tower",
                permission: true,
                pageType: "view",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
        };
        console.log("decodedString", decodedString);
        const decodedData = decodedString;
        console.log("decodedData", decodedData);
        dispatch(updateAccessibility(decodedData));
        const _allowedRoutes = [];
        const _restrictedRoutes = [];
        Object.keys(decodedData).forEach((mod) => {
          const module = decodedData[mod];
          if (module?.access) {
            module?.routes?.forEach((route) => {
              if (route?.permission) {
                _allowedRoutes.push(route?.path);
              } else {
                _restrictedRoutes.push(route?.path);
              }
            });
          }
        });
        setAccessibility(_allowedRoutes);
        setRestrictedRoutes(_restrictedRoutes);
        const _menu = [];
        menu?.forEach((item) => {
          if (item?.subMenu?.length > 0) {
            const subMenu = [];
            item?.subMenu?.forEach((subItem) => {
              if (subItem?.subMenu?.length > 0) {
                const _subMenuChildren = [];
                subItem?.subMenu?.forEach((subSubItem) => {
                  if (_allowedRoutes.includes(subSubItem?.link)) {
                    _subMenuChildren.push({
                      text: subSubItem?.text,
                      link: subSubItem?.link,
                      icon: subSubItem?.icon,
                    });
                  }
                });
                if (_subMenuChildren.length > 0) {
                  subMenu.push({
                    text: subItem?.text,
                    icon: subItem?.icon,
                    active: false,
                    subMenu: _subMenuChildren,
                  });
                }
                return;
              }
              if (_allowedRoutes.includes(subItem?.link)) {
                subMenu.push({
                  text: subItem?.text,
                  icon: subItem?.icon,
                  link: subItem?.link,
                });
              } else {
                if (subItem?.alt?.length > 0) {
                  const altLink = subItem?.alt?.find((link) =>
                    _allowedRoutes.includes(link)
                  );
                  if (altLink) {
                    subMenu.push({
                      text: subItem?.text,
                      icon: subItem?.icon,
                      link: altLink,
                    });
                  }
                }
              }
            });
            if (subMenu.length > 0) {
              _menu.push({
                text: item?.text,
                subMenu: subMenu,
                icon: item?.icon,
              });
            }
          } else {
            if (_allowedRoutes.includes(item?.link)) {
              _menu.push({
                text: item?.text,
                link: item?.link,
                icon: item?.icon,
              });
            } else if (item?.alt?.length > 0) {
              const altLink = item?.alt?.find((link) =>
                _allowedRoutes.includes(link)
              );
              if (altLink) {
                _menu.push({
                  text: item?.text,
                  icon: item?.icon,
                  link: altLink,
                });
              }
            }
          }
        });
        if (!_allowedRoutes?.includes("dashboard")) {
          _menu.unshift({
            text: "",
            link: "home",
            icon: <HomeOutlined style={{ fontSize: "18px" }} />,
          });
        }
        dispatch(updateMenuData(_menu));
        dispatch(updateAllowedRoutes(_allowedRoutes));
      } catch (error) {
        console.log("error", error);
      }
    }
  }, [currentUser]);

  useEffect(() => {
    const isAuthenticated = Cookies.get("access-token");
    if (!isAuthenticated && !globalRoutes?.includes(window.location.pathname)) {
      window.location.href = "/";
    }
  }, []);

  return (
    <Routes>
      <Route path={`${process.env.PUBLIC_URL}`} element={<Layout />}>
        <Route path="home" element={<DefaultDashboardPage />} />
        {accessibility?.map(
          (path) =>
            routesMap[path] && (
              <Route key={path} path={path} element={routesMap[path]} />
            )
        )}
        {restrictedRoutes?.map((path) => (
          <Route path={path} element={<div> Unauthorized Access</div>} />
        ))}
        <Route path="notifications" element={<NotificationMain />} />
        <Route path="privacy" element={<Faq />}></Route>
        <Route
          path="user-profile-regular"
          element={<UserProfileRegular />}
        ></Route>
        <Route
          path="user-profile-notification"
          element={<UserProfileNotification />}
        ></Route>
        <Route
          path="user-profile-activity"
          element={<UserProfileActivity />}
        ></Route>
        <Route
          path="excelexport-requested-list"
          element={<ExcelExportRequestedList />}
        ></Route>
        <Route path="bulk-upload-list" element={<BulkUploadList />}></Route>
        <Route
          path="user-profile-setting"
          element={<UserProfileSetting />}
        ></Route>
      </Route>

      <Route path={`${process.env.PUBLIC_URL}`} element={<LayoutNoSidebar />}>
        <Route path="auth-success" element={<Success />}></Route>
        <Route path="auth-register" element={<Register />}></Route>
        <Route index element={<Login setIsLoggedIn={setIsLoggedIn} />}></Route>

        <Route
          path="*"
          element={
            accessibility.length === 0 ? (
              <>
                <Flex align="center" gap="middle" className="pageLoader">
                  <Spin size="large" className="m-auto" />
                </Flex>
              </>
            ) : (
              <Error404Modern />
            )
          }
        ></Route>
      </Route>
    </Routes>
  );
};
export default Pages;
